import { T } from "@/locales";

export const rules = {
  location_out: [{ required: true, message: T("请选择源库位"), trigger: "change" }],
  material: [{ required: true, message: T("请选择货品"), trigger: "change" }],
  sub_batch_out: [{ required: true, message: T("请选择批次"), trigger: "change" }],
  transfer_quantity: [{ required: true, message: T("请输入移库数量"), trigger: "change" }],
  location_in: [{ required: true, message: T("请选择目标库位"), trigger: "change" }],
};
